import React, { PureComponent } from 'react';

import { withGroupState } from 'src/ver2/pages/group/context';
import GroupAvatar from 'src/ver2/components/group/avatar';
import SchoolRect from 'src/ver2/components/school/schoolRect';
import { NumberText } from 'src/ver2/containers/lowlavel/numberText';
import PlaceRect from 'src/ver2/containers/lowlavel/placeRect';
import { Tooltip } from 'antd';

import Loader from 'src/ver2/components/loader';
import { Link } from 'react-router-dom';

import './style.css';

// class BigGroupPlashka
// classname: big_group_plashka

/**
  Это просто типовая плашка, копировать отсюда
 */

class BigGroupPlashka extends PureComponent {

    // constructor(props) {
    //     super(props);
    // }

    nameRef = React.createRef();
    infoContainerRef = React.createRef();
    nameObserver = null;

    componentDidMount() {
        this.ensureNameObserver();
        this.fitName();
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.fitName());
        }
        window.addEventListener('resize', this.onWindowResize);
    }

    componentDidUpdate() {
        this.ensureNameObserver();
        this.fitName();
    }

    componentWillUnmount() {
        if (this.nameFrame) cancelAnimationFrame(this.nameFrame);
        if (this.nameObserver && this.nameObserver.disconnect) {
            this.nameObserver.disconnect();
        }
        this.nameObserver = null;
        window.removeEventListener('resize', this.onWindowResize);
    }

    /**
     * Наблюдаем за шириной контейнера названия (не за самим текстом —
     * иначе изменение font-size вызывало бы новое срабатывание и петлю).
     */
    ensureNameObserver = () => {
        if (this.nameObserver || typeof ResizeObserver === 'undefined') return;
        const el = this.infoContainerRef && this.infoContainerRef.current;
        if (!el) return;
        this.nameObserver = new ResizeObserver(() => this.fitName());
        this.nameObserver.observe(el);
    }

    onWindowResize = () => {
        this.fitName();
    }

    /**
     * Не даём названию группы переноситься на вторую строку.
     * Базовый размер задаём ЯВНО (не читаем из DOM, чтобы не застрять
     * на старом ужатом !important-значении):
     *  - мобильная вёрстка — 25px (как в style.css);
     *  - ПК — height * 0.3 (как в inline fontSize).
     */
    fitName = () => {
        const el = this.nameRef && this.nameRef.current;
        if (!el) return;

        const text = (el.textContent || '').trim();
        if (!text) return;

        const isMobile = this.props.isMobile;
        const baseSize = isMobile ? 25 : (this.nameBaseSize || parseFloat(getComputedStyle(el).fontSize) || 20);

        const applySize = (size) => {
            // 'important' — чтобы перебить мобильный font-size из CSS
            el.style.setProperty('font-size', `${size}px`, 'important');
        };

        // контейнер ещё не размечен — не ужимаем (подождём ResizeObserver/rAF)
        if (!el.clientWidth) return;

        applySize(baseSize);
        if (el.scrollWidth <= el.clientWidth + 1) return;

        // бинарный поиск максимального размера, при котором текст влезает в одну строку
        const MIN_SIZE = 8;
        let low = MIN_SIZE;
        let high = baseSize;
        let best = baseSize;

        let iteration = 0;
        while (low <= high && iteration < 60) {
            iteration++;
            const mid = Math.round(((low + high) / 2) * 2) / 2; // шаг 0.5px
            applySize(mid);
            if (el.scrollWidth <= el.clientWidth + 1) {
                best = mid;
                low = mid + 0.5;
            } else {
                high = mid - 0.5;
            }
        }

        applySize(best);
    }

    medalsCount = () => {

        const { Students } = this.props;
        if (!Students || !Students.length) return null;

        let result = { Gold: 0, Silver: 0, Bronze: 0 };
        for (let i = 0; i < Students.length; i++) {
            if (Students[i].Gold) result.Gold += Students[i].Gold;
            if (Students[i].Silver) result.Silver += Students[i].Silver;
            if (Students[i].Bronze) result.Bronze += Students[i].Bronze;
        }

        if (!result.Gold && !result.Silver && !result.Bronze) return null;

        return result;
    }

    MedalBlock = ({ height }) => {

        const medalsCount_ = this.medalsCount();

        if (!medalsCount_) return null;

        const medals = <div className='big_group_plashka_medals'>
            <PlaceRect height={height * 0.20} Place={1} PlaceName={medalsCount_.Gold} asMedal={true} />
            <PlaceRect height={height * 0.20} Place={2} PlaceName={medalsCount_.Silver} asMedal={true} />
            <PlaceRect height={height * 0.20} Place={3} PlaceName={medalsCount_.Bronze} asMedal={true} />
        </div>

        return <NumberText count={medals} text={'МЕДАЛИ'} height={height * 0.3} />
    }

    render() {

        const { Group, upperStyle, Students } = this.props;
        const { width, height } = upperStyle;

        // базовый размер шрифта названия на ПК (мобила перекрывает CSS-правилом 25px)
        this.nameBaseSize = height * 0.3;

        if (!Group) return <div style={{ width, height }} className='big_group_plashka'>
            <Loader />
        </div>

        const { Id, Name, SchoolId, Region } = Group;
        console.log('Group', Group);

        return <div style={{ width, height }} className='big_group_plashka'>
            <div style={{ width: height, height: height }} className='big_group_plashka___avatar_back'>
                <GroupAvatar size={height} groupId={Id} />
            </div>
            <div style={{ width: height, height: height }} className='big_group_plashka___avatar_container'>
                <GroupAvatar size={height * 0.75} groupId={Id} />
            </div>
            <div ref={this.infoContainerRef} style={{ width: (width - height), height: height }} className='big_group_plashka___info_container'>
                <div ref={this.nameRef} style={{ fontSize: height * 0.3, whiteSpace: 'nowrap' }} className='big_group_plashka___info_container___name'>
                    {Name}
                </div>
                {/* <div className='big_group_plashka___info_container___info'>
                </div>*/}
                <div className='big_group_plashka___info_container___school_group_cordao'>
                    <SchoolRect
                        width={height * 0.3}
                        SchoolId={SchoolId}
                    />
                    {(Students && Students.length) ? <NumberText count={Students.length} text={'СОСТАВ'} height={height * 0.3} /> : null}
                    <this.MedalBlock height={height} />
                    {(Region) ?

                        <Tooltip placement='top' title={'Регион, от которого в основном выступает группа: ' + this.props.client.regions[Region].title}>
                            <Link to={`/region/${Region}`}>
                                <span className='big_group_plashka__region'>
                                    <NumberText count={this.props.client.getRegionName(Region)} text={'РЕГИОН'} height={height * 0.3} upperAutoFit upperMaxFontSize={this.props.isMobile ? 12 : 20} />
                                </span>
                            </Link>
                        </Tooltip>
                        : null}
                </div>
            </div>
        </div >
    }

}

export default withGroupState(`
Group,
isGroupReady,

Students,

client,
iamuser,
isMobile,
`)(BigGroupPlashka)